import { isValidPhoneNumber } from 'libphonenumber-js/mobile'

export const classNames = (...rest: any[]) => rest.filter(Boolean).join(' ')

export const validateIsNotBlank = <T extends string>(
  value?: T,
): string | undefined | React.ReactElement => {
  if (!value?.length) return 'Обязательное поле'
}

export const validateIsNotBlankWithLocale = <T extends string>(
  value?: T,
): string | undefined | React.ReactElement => {
  if (!value?.length) return 'validation.required'
}

export const validatePhone = (value: string): string | undefined | React.ReactElement => {
  if (!isValidPhoneNumber(value)) return 'Неправильный номер'
}

export const validatePhoneWithLocale = (value: string): string | undefined => {
  if (!isValidPhoneNumber(value)) return 'validation.phone.wrongNumber'
}

const passwordRegexp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/
export const validateNewPassword = (value?: string) => {
  if (!value) return
  if (value.includes(' ')) return 'Пароль не должен содержать пробелов'
  if (value.length > 100) return 'Пароль не должен содержать более 100 символов.'
  if (!onlyLatinLettersRegexp.test(value)) return 'Пароль должен содержать только латинские буквы'
  if (!passwordRegexp.test(value))
    return 'Пароль должен содержать не менее 8 символов, 1 цифру, 1 букву нижнего регистра, 1 букву верхнего регистра'
}

const PASS_MAX_LENGTH = 100
const onlyLatinLettersRegexp = /^([^\p{L}]|[A-Za-z])+$/u
export const validateNewPasswordWithLocale = (value?: string) => {
  if (!value) return
  if (value.includes(' ')) return 'validation.password.noSpaces'
  if (value.length > PASS_MAX_LENGTH) return 'validation.password.tooLong'
  if (!onlyLatinLettersRegexp.test(value)) return 'validation.password.onlyLatin'
  if (!passwordRegexp.test(value)) return 'validation.password.notSecure'
}

const emailRegexpMultiLanguages = /^[\p{L}\p{N}._%+-]+@[\p{L}\p{N}-]+(?:\.[\p{L}\p{N}-]{2,})+$/u

export const validateEmail = (value: string): string | undefined => {
  if (!value) return
  if (!emailRegexpMultiLanguages.test(value))
    return 'Введите действительный адрес электронной почты'
}

const EMAIL_MAX_LENGTH = 320 // {64}@{255} but real addresses are often less than 256
export const validateEmailWithLocale = (
  value?: string,
): string | undefined | React.ReactElement => {
  if (!value) return ''
  // if (value.includes(' ')) return 'validation.password.noSpaces'
  if (!value || !emailRegexpMultiLanguages.test(value)) return 'validation.email.validEmail'
  if (value.length > EMAIL_MAX_LENGTH) return 'validation.email.tooLong'
}
